import { apiPost } from '../api'

export const save_interviews = data => {
  return apiPost({
    endpoint: 'interviews/save_interview',
    data: data
  })
}
